module.exports = __webpack_public_path__ + "af1d9b7cdc7a49de03b96528a2ee6ddf.svg";